// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"SectionI_TheComp__eWZ22"};